import { useModel } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { RemittanceAdvice } from "../../api/remittanceAdvice";
import { RemittanceAdviceData } from "../../api/remittanceAdviceChange";
import { RemittanceAdviceCount } from "../../api/remittanceAdviceCount";
import { ConfirmAssetsDataStep } from "../confirm-assets-data-step";
import { RemittanceAdviceExternalSystems } from "./externalSystems";
import { RemittanceAdviceForm } from "./remittance-advice-form";
import { RemittanceAdviceQuerry } from "./remittance-advice-querry";
import { RemittanceAdviceTableColumns } from "./remittance-advice-table-columns";

export const ConfirmRemittanceAdvicesDataStep = ({ isEdit, job, next, cancel, startOver, $refreshEvents }: { isEdit: boolean, job, next?, cancel?, startOver?, $refreshEvents? }) => {
    const remittanceAdviceChanges = useModel(RemittanceAdviceData);
    const remittanceAdviceCountModel = useModel(RemittanceAdviceCount);
    const remittanceAdviceQuerryModel = useModel(RemittanceAdviceQuerry);

    return <>
        <ConfirmAssetsDataStep
            isEdit={isEdit}
            job={job}
            assetName="Remittance Advice"
            assetType={AssetType.remittanceAdvice}
            assetModel={RemittanceAdvice}
            countModel={remittanceAdviceCountModel}
            queryModel={remittanceAdviceQuerryModel}
            tableColumns={RemittanceAdviceTableColumns}
            assetChanges={remittanceAdviceChanges}
            next={next} cancel={cancel} startOver={startOver}
            externalSystems={RemittanceAdviceExternalSystems}
            $refreshEvents={$refreshEvents}
            assetForm={remittanceAdvice => <RemittanceAdviceForm remittanceAdvice={remittanceAdvice} confirmDataStep={true} />}
        />
    </>
}